
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { useEffect, useRef, useState } from "react";
import NavBar from "./components/navabar.component";
import Home from "./components/Home.component";
import Footer from "./components/Footer.component";
import About from "./components/About.component";
import InitGsap from "./utils/InitGsap.util";
import Skill from "./components/Skill.component";
import { list_skill_group } from "./utils/list_skill_group.util";
import InitGsapSkill from "./utils/InitGsapSkill.util";
import HomeIconsGsap from "./utils/HomeIconsGsap.util";
import JavaScriptOath from "./utils/JavaScriptOath.util";
import list_project from "./utils/list_project.util.json";
import Oath from "./components/Oath.component";
import Playground from "./components/Playground.component";
import InitPlayground from "./utils/InitPlayground.util";
import AudioComponent from "./components/Audio.component";


gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

function App() {

  const homeRef = useRef()
  const aboutRef = useRef()
  const skillRef = useRef()
  const oathRef = useRef()
  const playgroundRef = useRef()
  const contactRef = useRef()
  const manzaRef = useRef()
  const frontendRef = useRef()
  const backendRef = useRef()
  const aboutDescriptionRef = useRef()
  const aboutProfilePhotoRef = useRef()
  const projectsRef = useRef()

  const oath1Ref = useRef()
  const oath2Ref = useRef()
  const oath3Ref = useRef()
  const oath4Ref = useRef()
  const oath5Ref = useRef()
  const oath6Ref = useRef()

  const rightSideRefs = useRef([]);
  const [getRightSiderefs, setRightSiderefs] = useState([])

  const skillsGroupRef = useRef([]);
  const [getSkillsGroupRef, setSkillsGroupRef] = useState([])

  const [getIsPlay, setIsPlay] = useState(false)

  const skillsRef = useRef([]);
  const [getSkillsRef, setSkillsRef] = useState([])


  const audioRef = useRef(null);

  const endedAudioFunction = () => {

    audioRef.current.play()
    setIsPlay(true)
  }

  useEffect(() => {
    audioRef.current.addEventListener('ended', endedAudioFunction);
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      audioRef.current.removeEventListener('ended', endedAudioFunction);
    };
  }, []);

  useEffect(() => {
    if (getRightSiderefs.length > 0) {
      InitGsap({
        ScrollTrigger,
        gsap,
        manzaRef,
        homeRef,
        aboutRef,
        frontendRef,
        backendRef,
        aboutDescriptionRef,
        aboutProfilePhotoRef,
        contactRef,
      })

      HomeIconsGsap({
        getRightSiderefs,
        gsap,
      })

      JavaScriptOath({
        gsap,
        oathRef,
        oath1Ref,
        oath2Ref,
        oath3Ref,
        oath4Ref,
        oath5Ref,
        oath6Ref
      })

      InitPlayground({
        gsap,
        playgroundRef,
        projectsRef,
      })

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getRightSiderefs])

  useEffect(() => {
    var total_config_list_skill = 0
    var total_list_skill = 0
    list_skill_group?.forEach((skill_group) => {
      skill_group?.forEach((skill) => {
        total_config_list_skill = total_config_list_skill + 1
      })
    })

    getSkillsRef?.forEach((skill_group) => {
      if (skill_group?.length > 0) {
        skill_group?.forEach((skill) => {
          total_list_skill = total_list_skill + 1
        })
      }
    })

    if (getSkillsGroupRef?.length === list_skill_group?.length &&
      total_config_list_skill === total_list_skill) {
      InitGsapSkill({
        gsap,
        getSkillsGroupRef,
        getSkillsRef,
      })
    }
  }, [getSkillsGroupRef, getSkillsRef])

  const addRightSideRef = (el) => {
    rightSideRefs.current.push(el);
    setRightSiderefs(rightSideRefs.current)
  }

  const sendEmail = () => {
    window.location = "mailto:zaiman670@gmail.com"
  }

  const addSkillGroup = ({ el }) => {
    const temp_group = skillsGroupRef.current
    if (temp_group?.length < list_skill_group?.length) {
      temp_group.push(el);
    }

    setSkillsGroupRef(temp_group)
  }

  const addSkill = ({ el, index_skill_group }) => {
    const temp_skills = skillsRef.current
    if (temp_skills[index_skill_group]) {
      if (temp_skills[index_skill_group]?.length < list_skill_group[index_skill_group]?.length) {
        temp_skills[index_skill_group]?.push(el)
      }
    } else {
      temp_skills?.push([el])
    }

    setSkillsRef(temp_skills)
  }

  return (
    <div className="bg-[#FFFFFF] font-['Roboto'] overflow-hidden">
      <AudioComponent
        audioRef={audioRef}
        getIsPlay={getIsPlay}
        setIsPlay={setIsPlay}
      />
      {/* NAVBAR */}
      {/* <NavBar
        gsap={gsap}
      /> */}
      {/* BODY */}
      <Home
        homeRef={homeRef}
        addRightSideRef={addRightSideRef}
        manzaRef={manzaRef}
      />
      <About
        aboutRef={aboutRef}
        frontendRef={frontendRef}
        backendRef={backendRef}
        aboutProfilePhotoRef={aboutProfilePhotoRef}
        aboutDescriptionRef={aboutDescriptionRef}
        sendEmail={sendEmail}
      />
      <Skill
        skillRef={skillRef}
        addSkillGroup={addSkillGroup}
        addSkill={addSkill}
      />
      <Oath
        oathRef={oathRef}
        oath1Ref={oath1Ref}
        oath2Ref={oath2Ref}
        oath3Ref={oath3Ref}
        oath4Ref={oath4Ref}
        oath5Ref={oath5Ref}
        oath6Ref={oath6Ref}
      />
      <Playground
        playgroundRef={playgroundRef}
        projectsRef={projectsRef}
        list_project={list_project}
      />
      <Footer
        contactRef={contactRef}
        sendEmail={sendEmail}
      />
    </div>
  );
}

export default App;
